import Error from './ErrorMsg';
export default Error;
